import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useSessionNonStream } from '@/hooks/useSwr';

import { Breadcrumb, BreadcrumbData } from '../../components/Breadcrumbs';

export function DatasetSessionCompareCrumb(props: Partial<BreadcrumbData>) {
  const [searchParams, _] = useSearchParams();
  const selectedSessionsParam = searchParams.get('selectedSessions');

  const count = selectedSessionsParam
    ? selectedSessionsParam.split(',').length
    : 0;

  // include_stats because we already do that fetch on the dataset page, so this is just a cache hit
  const singleSession = useSessionNonStream(
    selectedSessionsParam && count === 1
      ? selectedSessionsParam.split(',')[0]
      : null,
    { include_stats: true }
  );
  const name = useMemo(() => {
    if (count === 1) {
      return singleSession.data?.name ?? 'Experiment';
    }
    return `Comparing ${count} Experiments`;
  }, [singleSession, count]);

  return <Breadcrumb name={name} {...props} />;
}
